<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <b-overlay
                    variant="white"
                    :show="showLoading"
                    spinner-variant="primary"
                    blur="0"
                    opacity=".75"
                    rounded="sm"
                >
                    <div class="p-1">
                        <form class="" @submit.prevent="submitForm">
                            <div class="row">
                                <div class="form-group col-12 col-md-3">
                                    <label for="phone24">Descripción:</label>
                                    <b-form-input v-model="installation_type.type" autocomplete="off"/>
                                    <span v-if="validation_installation_type.type" class="text-danger">
                                      {{ validation_installation_type.type }}
                                    </span>
                                </div>
                                <div class="form-group col-12 col-md-3">
                                  <label for="phone24">Código:</label>
                                  <b-form-input v-model="installation_type.code" autocomplete="off"/>
                                  <span v-if="validation_installation_type.code" class="text-danger">
                                        {{ validation_installation_type.code }}
                                      </span>
                                </div>
                                <div class="form-group col-12 col-md-3 d-none">
                                  <label for="phone24">Garantia:</label>
                                  <b-form-input v-model="installation_type.installation_type_assurance" autocomplete="off"/>

                                </div>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </b-overlay>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput} from 'bootstrap-vue'
import {mapState} from "vuex"
import {VHE_AUXILIAR_INSTALLATIONTYPES_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
    getterType: 'installationTypesVhe/getField',
    mutationType: 'installationTypesVhe/updateField',
})

export default {
    name: "FormView",
    components: {
        BCol,
        BRow,
        BCard,
        BFormInput,
        BOverlay,
    },
    data() {
        return {
            edit: false,
            showLoading: false,
        }
    },
    computed: {
        ...mapState('auxiliariesInstallationTypesVhe', ['validation_installation_type']),
        ...mapFields({
            installation_type: 'installation_type',
        }),
    },
    created() {
        this.$store.commit('auxiliariesInstallationTypesVhe/RESET_STATE')
        this.$store.commit('auxiliariesInstallationTypesVhe/CLEAR_VALIDATION')
        if (this.$route.params.id) {
            this.edit = true
            this.getInstallationTypes()
        } else {
            this.edit = false
        }
        this.$root.$refs.auxiliariesInstallationTypesForm = this
    },
    methods: {
      getInstallationTypes() {
            this.showLoading = true

            this.$store.dispatch('installationTypesVhe/findInstallationTypes', {
                id: this.$route.params.id ?? this.installation_type.id
            })
                .then(response => {
                  this.showLoading = false
                })
                .catch(error => {
                    this.showLoading = false
                })
        },
        cancel() {
            this.$router.push(VHE_AUXILIAR_INSTALLATIONTYPES_LIST)
        },
        createAuxiliar() {
            this.$store.dispatch('installationTypesVhe/createInstallationTypes', this.installation_type)
                .then(response => {
                    helper.showToast('Tipo de instalación creado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(VHE_AUXILIAR_INSTALLATIONTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al crear tipo de instalación', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        updateAuxiliar() {
            this.$store.dispatch('installationTypesVhe/updateInstallationTypes', this.installation_type)
                .then(response => {
                    helper.showToast('Tipo de instalación editado correctamente!', 'CheckIcon', 'success')
                    this.$router.replace(VHE_AUXILIAR_INSTALLATIONTYPES_LIST)
                })
                .catch(error => {
                    helper.showToast('Error al editar tipo de instalación', 'AlertOctagonIcon', 'danger')
                    console.log(error)
                })
        },
        submitForm() {
            if (this.$route.params.id) {
                this.updateAuxiliar()
            } else {
                this.createAuxiliar()
            }
        },
    },
}
</script>
